import React from 'react';

const TwitterWidget = () => {
  return (
    <>
      <h5>
        <b>Twitter Widgets</b>
      </h5>
      {/* to do correct */}
      <p>Trustpilot Widget allows you to easily embed Trustpilot reviews on your web app.</p>
      <br />
    </>
  );
};

export default TwitterWidget;
